// useUserEmail.js
import {useAuth0} from "@auth0/auth0-vue";

/**
 * Levert het e-mailadres van de ingelogde gebruiker op.
 * Kijkt eerst in het door /users/index.php teruggegeven object in localStorage
 * en valt terug op het e-mailadres uit Auth0 (dat is ook het adres dat bij het
 * inloggen naar het backend is gestuurd).
 */
export function useUserEmail() {
    const auth0 = useAuth0();

    const getUserEmail = () => {
        try {
            const storage = localStorage.getItem('user');
            if (storage) {
                const data = JSON.parse(storage)?.data;
                if (data && typeof data === 'object') {
                    const email = data.email || data.user_email || data.userEmail || data.mail;
                    if (email) {
                        return email;
                    }
                }
            }
        } catch (e) {
            // ongeldige JSON in localStorage: negeren en terugvallen op Auth0
        }
        return auth0.user?.value?.email || null;
    };

    return {getUserEmail};
}
